<template>
  <el-dialog
    title="添加路线"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >
    <div class="product-add pb50">
      <el-form
        :key="dialogVisible"
        size="small"
        :model="form"
        ref="form"
        label-width="100px"
      >
        <!-- 主Tab导航 -->
        <el-tabs v-model="activeTab" type="card">
          <!-- 基本信息Tab -->
          <el-tab-pane label="基本信息" name="basic">
            <el-form-item label="路线名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入路线名称"
                class="max-w460"
              ></el-input>
            </el-form-item>

   
            <el-form-item label="路线类别" prop="route_category_ids">
              <el-cascader
                v-model="form.category_display_ids"
                placeholder="请选择路线类别"
                class="max-w460"
                :options="category"
                :props="{ multiple: true, emitPath: false, value: 'route_category_id', label: 'name', children: 'children', checkStrictly: true }"
                filterable
                clearable
                @change="handleCategoryChange"
              ></el-cascader>
            </el-form-item>

      

            <el-form-item label="价格" prop="price">
              <el-input
                v-model="form.price"
                placeholder="请输入价格"
                class="max-w460"
                type="number"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>

            <el-form-item label="定金" prop="deposit">
              <el-input
                v-model="form.deposit"
                placeholder="请输入定金"
                class="max-w460"
                type="number"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>

            <el-form-item label="封面图片" prop="image">
              <div class="draggable-list">
                <draggable class="wrapper" v-model="form.image">
                  <transition-group>
                    <div
                      v-for="(item, index) in form.image"
                      :key="item.file_path"
                    >
                      <div class="item">
                        <img v-img-url="item.file_path" alt="file_path" />
                        <a
                          href="javascript:void(0);"
                          class="delete-btn"
                          @click.stop="deleteImg(index, 'album')"
                        >
                          <i class="el-icon-close"></i>
                        </a>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <div
                  v-if="form.image.length === 0"
                  class="item img-select"
                  @click="openProductUpload('album')"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </el-form-item>

            <!-- 分享朋友圈封面 -->
            <el-form-item label="朋友圈分享封面">
              <div style="color:#999;margin-bottom:10px;">建议 1:1 比例（如 500x500）</div>
              <div class="draggable-list">
                <div v-if="form.share_timeline_image" class="item">
                  <img v-img-url="form.share_timeline_image" alt="share_timeline_image" />
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="form.share_timeline_image = ''">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
                <div v-if="!form.share_timeline_image" class="item img-select" @click="openProductUpload('shareTimeline')">
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </el-form-item>

            <!-- 分享好友封面 -->
            <el-form-item label="好友分享封面">
              <div style="color:#999;margin-bottom:10px;">建议 5:4 比例（如 500x400）</div>
              <div class="draggable-list">
                <div v-if="form.share_app_image" class="item">
                  <img v-img-url="form.share_app_image" alt="share_app_image" />
                  <a href="javascript:void(0);" class="delete-btn" @click.stop="form.share_app_image = ''">
                    <i class="el-icon-close"></i>
                  </a>
                </div>
                <div v-if="!form.share_app_image" class="item img-select" @click="openProductUpload('shareApp')">
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="联系人">
              <el-input
                v-model="form.liaison"
                placeholder="请输入联系人姓名及职务"
                class="max-w460"
              ></el-input>
            </el-form-item>

            <el-form-item label="联系电话">
              <el-input
                v-model="form.contact_phone"
                placeholder="请输入联系电话"
                class="max-w460"
              ></el-input>
            </el-form-item>

            <el-form-item label="虚拟报名人数">
              <el-input
                v-model="form.virtual_role"
                placeholder="请输入虚拟报名人数"
                class="max-w460"
              ></el-input>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                placeholder="请输入排序数字，越小越靠前"
                class="max-w460"
              ></el-input>
            </el-form-item>

            <el-form-item label="是否推荐" prop="recommend">
              <el-switch
                v-model="form.recommend"
                :active-value="1"
                :inactive-value="0"
                active-text="推荐"
                inactive-text="不推荐"
              ></el-switch>
            </el-form-item>

            <!-- 地图设置子Tab -->
            <el-tabs v-model="selectMap">
              <el-tab-pane label="设置集合地" name="1">
                <el-form-item label="集合地">
                  <el-input
                    v-model="form.address"
                    placeholder="请输入集合地"
                    class="max-w460"
                  ></el-input>
                </el-form-item>
                <el-form-item label="坐标">
                  <el-input
                    v-model="form.coordinate"
                    class="max-w460"
                  ></el-input>
                  <Getpoint
                    v-if="selectMap == 1"
                    :form="form"
                    @getMapdata="getMapdataFunc"
                    @chose="choseFunc"
                  ></Getpoint>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="设置目的地" name="2">
                <el-form-item label="目的地">
                  <el-input
                    v-model="form.destination"
                    placeholder="请输入目的地"
                    class="max-w460"
                  ></el-input>
                </el-form-item>
                <el-form-item label="坐标">
                  <el-input
                    v-model="form.coordinate1"
                    class="max-w460"
                  ></el-input>
                  <Getpoint
                    v-if="selectMap == 2"
                    :form="form"
                    @getMapdata="getMapdataFunc1"
                    @chose="choseFunc1"
                  ></Getpoint>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>

          <!-- 在现有的el-tabs中添加新的tab-pane -->
          <el-tab-pane label="场次设置" name="sessions">
            <el-form-item label="批次管理">
              <div class="session-management">
                <!-- 添加批次按钮 -->
                <el-button
                  type="primary"
                  size="small"
                  @click="addSession"
                  style="margin-bottom: 15px;"
                >
                  添加批次
                </el-button>

                <!-- 场次表格 -->
                <el-table
                  :data="form.sessions"
                  border
                  style="width: 100%"
                  size="small"
                >
                  <el-table-column prop="date" label="活动日期" width="180">
                    <template slot-scope="scope">
                      <el-date-picker
                        v-model="scope.row.date"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                      ></el-date-picker>
                    </template>
                  </el-table-column>

                  <el-table-column prop="weekday" label="星期几" width="120">
                    <template slot-scope="scope">
                      <span>{{ getWeekday(scope.row.date) }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="num" label="满团人数" width="150">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.num"
                        type="number"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column prop="num" label="虚拟报名人数" width="150">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.xnnum"
                        type="number"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="price"
                    label="120cm以下儿童价格(元)"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.children_price90"
                        type="number"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="120cm-140cm以下儿童价格(元)"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.children_price120"
                        type="number"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="成人/140cm以上儿童价格" width="150">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.adult_price"
                        type="number"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="房差" width="150">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.room_price"
                        type="number"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column prop="status" label="状态" width="150">
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.status"
                        placeholder="选择状态"
                        size="mini"
                      >
                        <el-option
                          v-for="item in statusOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <!-- <el-button
              size="mini"
              @click="editSession(scope.$index)"
            >编辑</el-button> -->
                      <el-button
                        size="mini"
                        type="danger"
                        @click="removeSession(scope.$index)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-tab-pane>

          <!-- 路线介绍Tab -->
          <el-tab-pane label="路线介绍" name="intro">
            <el-form-item label="路线介绍" prop="intro">
              <div class="edit_container">
                <Uediter
                  v-model="form.intro"
                  :text="introUeditor.text"
                  :config="introUeditor.config"
                  ref="introUe"
                ></Uediter>
              </div>
            </el-form-item>
          </el-tab-pane>

          <!-- 行程安排Tab -->
          <el-tab-pane label="行程安排" name="schedule">
            <el-form-item label="行程安排" prop="schedule">
              <div class="edit_container">
                <Uediter1
                  v-model="form.schedule"
                  id="ue2"
                  :text2="scheduleUeditor.text"
                  :config="scheduleUeditor.config"
                  ref="scheduleUe"
                ></Uediter1>
              </div>
            </el-form-item>
          </el-tab-pane>

          <!-- 费用说明Tab -->
          <el-tab-pane label="费用说明" name="fee">
            <el-form-item label="费用说明" prop="fee_exp">
              <div class="edit_container">
                <Uediter1
                  v-model="form.fee_exp"
                  id="ue3"
                  :text3="feeUeditor.text"
                  :config="feeUeditor.config"
                  ref="feeUe"
                ></Uediter1>
              </div>
            </el-form-item>
          </el-tab-pane>

          <!-- 注意事项Tab -->
          <el-tab-pane label="注意事项" name="remark">
            <el-form-item label="注意事项" prop="remark">
              <div class="edit_container">
                <Uediter1
                  v-model="form.remark"
                  id="ue4"
                  :text3="remarkUeditor.text"
                  :config="remarkUeditor.config"
                  ref="remarkUe"
                ></Uediter1>
              </div>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>

        <!--提交按钮-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>

      <!-- 图片上传组件 -->
      <!-- <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片</Upload
      > -->
      <Upload
        v-if="isProductUpload"
        :config="{ total: 1 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
      >
        上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import RouteApi from "@/api/route.js";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
import Uediter1 from "@/components/UE1.vue";
import Getpoint from "@/components/map/Getpoint.vue";
import Route_categoryApi from "@/api/route_category.js";

export default {
  components: {
    Upload,
    draggable,
    Uediter,
    Getpoint,
    Uediter1
  },
  data() {
    return {
      categoryRegionOptions: [],
      activeTab: "basic", // 当前激活的主Tab
      selectMap: "1", // 地图设置子Tab
      isupload: false,
      isImg: false,
      category: [],
      statusOptions: [
        { value: 0, label: "未开始" },
        { value: 1, label: "报名中" },
        { value: 2, label: "已结束" }
      ],

      // 各个富文本编辑器的配置
      introUeditor: {
        text: "",
        config: {
          initialFrameWidth: "100%",
          initialFrameHeight: 400
        }
      },
      scheduleUeditor: {
        text: "",
        config: {
          initialFrameWidth: "100%",
          initialFrameHeight: 400
        }
      },
      feeUeditor: {
        text: "",
        config: {
          initialFrameWidth: "100%",
          initialFrameHeight: 400
        }
      },
      remarkUeditor: {
        text: "",
        config: {
          initialFrameWidth: "100%",
          initialFrameHeight: 400
        }
      },

      form: {
        name: "",
        recommend: 0,
        virtual_role: "",
        code: "custom",
        children_price90: 0,
        children_price120: 0,
        adult_price: 0,
        num: 0,
        xnnum: 0,
        address: "",
        sessions: [],
        destination: "",
        coordinate: "",
        coordinate1: "",
        schedule: "",
        fee_exp: "",
        remark: "",
        sort: 50,
        intro: "",
        image: [],
        liaison: "",
        deposit: 0,
        route_category_ids: [],
        category_display_ids: [],
        category_region_map: {},
        share_timeline_image: "", // 朋友圈分享封面
        share_app_image: "", // 好友分享封面

        contact_phone: ""
      },
      loading: false,
      // rules: {
      //   name: [{ required: true, message: "请输入路线名称", trigger: "blur" }],
      //   price: [{ required: true, message: "请输入价格", trigger: "blur" }],
      //   deposit: [{ required: true, message: "请输入定金", trigger: "blur" }],
      //   address: [{ required: true, message: "请输入集合地", trigger: "blur" }],
      //   coordinate: [
      //     { required: true, message: "请设置集合地坐标", trigger: "blur" }
      //   ],
      //   destination: [
      //     { required: true, message: "请设置目的地坐标", trigger: "blur" }
      //   ],
      //   route_category_ids: [
      //     {
      //       required: true,
      //       type: "array",
      //       min: 1,
      //       message: "请选择路线类别",
      //       trigger: "change"
      //     }
      //   ],
      //   image: [{ required: true, message: "请上传封面图片" }]
      // },
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getCategory();
    this.getProvinceOptions();
  },

  props: ["open_add"],
  watch: {
    "form.category_display_ids": function(newVal) {
      if (!newVal || newVal.length === 0) {
        this.form.route_category_ids = [];
        this.form.category_region_map = {};
        return;
      }

      let finalIds = [];

      newVal.forEach(id => {
        const categoryItem = this.findCategoryItem(this.category, id);
        if (categoryItem && categoryItem.children && categoryItem.children.length > 0) {
          categoryItem.children.forEach(child => {
            if (!finalIds.includes(child.route_category_id)) {
              finalIds.push(child.route_category_id);
            }
          });
        } else {
          if (!finalIds.includes(id)) {
            finalIds.push(id);
          }
        }
      });

      this.form.route_category_ids = finalIds;

      const map = { ...this.form.category_region_map };
      finalIds.forEach(id => {
        if (!map[id] && this.getRegionOptions(id).length > 0) {
          map[id] = "";
        }
      });

      Object.keys(map).forEach(id => {
        if (!finalIds.includes(Number(id))) {
          delete map[id];
        }
      });

      this.form.category_region_map = map;
    }
  },
  methods: {
    getCategoryName(cid) {
      const c = this.category.find(i => i.route_category_id === cid);
      return c ? c.name : "";
    },

    getRegionOptions(cid) {
      const c = this.category.find(i => i.route_category_id === cid);
      if (!c || !c.region_ids) return [];

      let ids =
        typeof c.region_ids === "string"
          ? c.region_ids.split(",").map(Number)
          : c.region_ids.map(Number);

      return this.provinceOptions.filter(p => ids.includes(p.id));
    },
    findCategoryItem(categories, id) {
      for (const item of categories) {
        if (item.route_category_id === id) {
          return item;
        }
        if (item.children && item.children.length > 0) {
          const found = this.findCategoryItem(item.children, id);
          if (found) return found;
        }
      }
      return null;
    },
    getProvinceOptions() {
      RouteApi.provinceOptions().then(res => {
        this.provinceOptions = res.data;
      });
    },
    // 切换Tab
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getCategory() {
      Route_categoryApi.list().then(res => {
        const data = res.data.list.data;
        this.category = data.filter(item => item.parent_id === 0);
      });
    },
    handleCategoryChange(selectedValues) {
      let finalIds = [];

      selectedValues.forEach(id => {
        const categoryItem = this.findCategoryItem(this.category, id);
        if (categoryItem && categoryItem.children && categoryItem.children.length > 0) {
          categoryItem.children.forEach(child => {
            if (!finalIds.includes(child.route_category_id)) {
              finalIds.push(child.route_category_id);
            }
          });
          if (!finalIds.includes(id)) {
            finalIds.push(id);
          }
        } else {
          if (!finalIds.includes(id)) {
            finalIds.push(id);
          }
        }
      });

      this.form.category_display_ids = finalIds;
    },
    addSession() {
      this.form.sessions.push({
        date: "",
        children_price90: this.form.children_price90 || 0,
        children_price120: this.form.children_price120 || 0,
        adult_price: this.form.adult_price || 0,
        num: this.form.num || 0,
        xnnum: this.form.xnnum || 0,
        status: 0, // 默认未开始
        route_batch_id: null // 新增场次没有ID
      });
    },

    // 删除场次
    removeSession(index) {
      this.$confirm("确定删除该场次吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.form.sessions.splice(index, 1);
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    },

    // 编辑场次
    editSession(index) {
      // 这里可以根据需要实现具体编辑逻辑
      // 例如打开一个对话框编辑选中行
      this.$message.info(`编辑第 ${index + 1} 条场次`);
    },

    // 根据日期获取星期几
    getWeekday(date) {
      if (!date) return "";
      const weekdays = ["日", "一", "二", "三", "四", "五", "六"];
      const day = new Date(date).getDay();
      return `星期${weekdays[day]}`;
    },

    // 地图相关方法
    getMapdataFunc(e) {
      console.log(e);
      this.form.coordinate = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },
    choseFunc(e) {
      this.form.coordinate = e.location.lat + "," + e.location.lng;
      this.form.address = e.address;
    },
    getMapdataFunc1(e) {
      this.form.coordinate1 = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },
    choseFunc1(e) {
      console.log("e", e);
      this.form.coordinate1 = e.location.lat + "," + e.location.lng;
      this.form.destination = e.address;
    },

    // 图片上传相关方法
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;

        e.forEach(element => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase();
          if (imgExpt.includes(ext)) {
            prevent = true;
          }
        });

        if (!prevent) {
          this.$message.error("图片类型有误，请选择正确的图片格式");
          return false;
        }

        if (this.code == "album") {
          // let imgs = this.form.image.concat(e);
          // this.$set(this.form, "image", imgs);
          this.$set(this.form, "image", e.slice(0, 1));
        } else if (this.code == "shareTimeline") {
          // 朋友圈分享封面
          if (e.length > 0) {
            this.$set(this.form, "share_timeline_image", e[0].file_path);
          }
        } else if (this.code == "shareApp") {
          // 好友分享封面
          if (e.length > 0) {
            this.$set(this.form, "share_app_image", e[0].file_path);
          }
        } else {
          // let imgs = this.form.bannar.concat(e);
          // this.$set(this.form, "bannar", imgs);
          this.$set(this.form, "bannar", this.form.bannar.concat(e));
        }
      }
      this.isProductUpload = false;
    },
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    },

    // 表单提交
    onSubmit() {
      // alert("111");

      if (!this.$refs.form) {
        this.$message.error("表单尚未初始化");
        return;
      }

      this.$refs.form.validate((valid, invalidFields) => {
        console.log("validate 执行了，valid =", valid);
        console.log("校验失败的字段:", invalidFields);

        if (!valid) {
          this.$message.error("表单校验未通过");
          return;
        }

        this.loading = true;

        RouteApi.add(this.form, true)
          .then(res => {
            this.loading = false;
            this.$message.success(res.msg);
            this.dialogFormVisible("success");
          })
          .catch(err => {
            this.loading = false;
            this.$message.error(err.message);
          });
      });
    },

    // 关闭弹窗
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: result || "" });
    },
    cancelFunc() {
      this.dialogFormVisible("cancel");
    }
  }
};
</script>

<style scoped>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
/* 添加状态标签样式 */
.status-tag {
  padding: 0 5px;
  border-radius: 3px;
  font-size: 12px;
}

.status-0 {
  /* 未开始 */
  background-color: #f0f2f5;
  color: #909399;
  border: 1px solid #dcdfe6;
}

.status-1 {
  /* 报名中 */
  background-color: #f0f9eb;
  color: #67c23a;
  border: 1px solid #c2e7b0;
}

.status-2 {
  /* 已结束 */
  background-color: #fef0f0;
  color: #f56c6c;
  border: 1px solid #fbc4c4;
}

/* 添加场次管理相关样式 */
.session-management {
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
}

.session-management .el-table {
  margin-top: 10px;
}

/* 调整日期选择器样式 */
.el-date-editor.el-input {
  width: 100%;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.max-w460 {
  max-width: 460px;
}

.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
}

.el-tabs {
  margin-bottom: 20px;
}

/* 富文本编辑器容器样式 */
.edit_container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/route/index/part/add.vue